"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _modalModule = _interopRequireDefault(require("./modal.module.css"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ModalBody = function ModalBody(props) {
  var id = props.id,
      children = props.children,
      contained = props.contained;
  return _react.default.createElement("div", {
    id: id ? id : null,
    className: (0, _classnames.default)(_modalModule.default["modal-body"], contained ? _modalModule.default["modal-body--contained"] : "")
  }, children);
};

ModalBody.propTypes = {
  /** String text that specifies a unique id for an HTML element. Consistent Id type: snake_case*/
  id: _propTypes.default.string,

  /** Boolean prop that when it is set to true it will restrict the width and height of the modal */
  contained: _propTypes.default.bool,
  children: _propTypes.default.any
};
var _default = ModalBody;
exports.default = _default;